<script>

import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import {useCartStore} from "@js/store/CartStore.js";
import CartList from "@js/components/Sections/Cart/CartList.vue";
import CartDelivery from "@js/components/Sections/Cart/CartDelivery.vue";
import CartForm from "@js/components/Sections/Cart/CartForm.vue";
import CartClearConfirmPopup from "@js/components/Sections/Cart/CartClearConfirmPopup.vue";
import IconAnimatedCheckMark from "@js/components/Icons/IconAnimatedCheckMark.vue";
import {Link} from "@inertiajs/vue3";
import IconCart from "@js/components/Icons/IconCart.vue";
import {onMounted} from "vue";

export default {
    name: "CartPage",
    components: {
        IconCart,
        Link,
        IconAnimatedCheckMark,
        CartClearConfirmPopup,
        CartForm,
        CartDelivery,
        CartList,
        Breadcrumbs,
        MobileTopBar

    },
    setup() {
        const cartStore = useCartStore();

        onMounted(() => {
            cartStore.cart_form_successfully_sent = false
        });

        return {cartStore};
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <div class="flex items-center text-2xl font-medium mb-3">
            <h1>Оформление заказа</h1>
        </div>
        <template v-if="cartStore.cart_form_successfully_sent">
            <div class="flex flex-col items-center justify-center my-10">
                <IconAnimatedCheckMark size="80"/>
                <p class="text-lg font-medium text-center text-[#7ac142] mt-5">
                    Заказ успешно оформлен!<br/> Наш менеджер скоро свяжемся с вами.
                </p>
                <Link :href="route('home')"
                      class="flex justify-center items-center text-black border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-medium rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer mt-5">
                    Вернуться на главную
                </Link>
            </div>
        </template>
        <template v-else>
            <div class="grid grid-cols-12 gap-5"
                 v-if="cartStore.items.length">
                <div class="col-span-12 md:col-span-8">
                    <div class="grid grid-cols-1 gap-5">
                        <CartList/>
                        <CartDelivery/>
                    </div>
                </div>
                <div class="col-span-12 md:col-span-4">
                    <div class="sticky top-24 self-start">
                        <CartForm/>
                    </div>
                </div>
            </div>
            <div v-else class="text-2xl font-medium mt-5">
                <div
                    class="flex flex-col items-center justify-center w-full bg-white p-5 border border-gray-200 shadow rounded-xl">
                    <div class="flex items-center justify-center border border-gray-200 rounded-full p-4 md:p-5 mb-5">
                        <IconCart class="w-7 h-7"/>
                    </div>
                    <div class="text-xl md:text-2xl font-bold text-gray-800 text-center mb-2">
                        Корзина пуста
                    </div>
                    <div class="text-base font-bold text-gray-800 text-center">
                        Добавьте товары в корзину, перейдя в каталог
                    </div>
                </div>
            </div>
        </template>
    </div>
    <CartClearConfirmPopup/>
</template>

<style scoped lang="scss">

</style>
